import { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const codeTheme = {
  ...oneDark,
  'pre[class*="language-"]': {
    ...oneDark['pre[class*="language-"]'],
    margin: 0,
    borderRadius: '0 0 12px 12px',
    background: '#121e16',
    border: 0,
    padding: 0,
    fontSize: '0.85rem',
    lineHeight: 1.55,
  },
  'code[class*="language-"]': {
    ...oneDark['code[class*="language-"]'],
    fontFamily: 'IBM Plex Mono, SFMono-Regular, Menlo, monospace',
  },
};

export const CodeSnippet = ({
  code,
  language = 'javascript',
  title = 'Script',
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (_) {
      setCopied(false);
    }
  };

  return (
    <div className="code-snippet">
      <div className="code-snippet-header">
        <span>{title}</span>
        <button className="code-copy" type="button" onClick={handleCopy}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <SyntaxHighlighter
        language={language}
        style={codeTheme}
        showLineNumbers
        wrapLongLines
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
};
